/**
 * API Configuration (whitelabel + HTTPS safe)
 * - Normaliza SIEMPRE a https
 * - Respeta basePath (e.g. /novvaspace) configurable por env
 * - Sin hardcode de host; toma el dominio actual o NEXT_PUBLIC_OC_ORIGIN
 *
 * ENV soportadas:
 *  - NEXT_PUBLIC_OC_ORIGIN:      (opcional) e.g. https://comunidad.novvaspace.com
 *  - NEXT_PUBLIC_OC_BASE_PATH:   (opcional) e.g. /novvaspace
 *  - NEXT_PUBLIC_BASE_URL:       (fallback SSR, si no usas las dos anteriores)
 */

const ensureHttps = (url: string) => {
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') u.protocol = 'https:';
    return u.origin; // sin path
  } catch {
    // Si llega algo como "comunidad.novvaspace.com"
    return `https://${url.replace(/^https?:\/\//, '').replace(/\/+$/, '')}`;
  }
};

const joinUrl = (origin: string, basePath?: string) => {
  const clean = (s: string) => s.replace(/\/+$/,'').replace(/^\/+/, '');
  const o = origin.replace(/\/+$/,''); // sin trailing slash
  const b = basePath ? '/' + clean(basePath) : '';
  return o + b;
};

export const getOcBaseUrl = (): string => {
  // 1) Si se define un ORIGIN explícito por env, úsalo (multi-tenant / whitelabel)
  const envOrigin = process.env.NEXT_PUBLIC_OC_ORIGIN;
  const envBasePath = process.env.NEXT_PUBLIC_OC_BASE_PATH || '';

  if (envOrigin) {
    return joinUrl(ensureHttps(envOrigin), envBasePath);
  }

  // 2) En el browser: usa el dominio actual (y normaliza a https)
  if (typeof window !== 'undefined') {
    const httpsOrigin = ensureHttps(window.location.origin);
    // Para localhost, puedes forzar un origin de pruebas si quieres
    if (httpsOrigin.includes('localhost')) {
      // Si en localhost tu OC corre en otro host, configúralo por env:
      const devOverride = process.env.NEXT_PUBLIC_BASE_URL || 'https://hubee.app';
      return joinUrl(ensureHttps(devOverride), envBasePath || '');
    }
    return joinUrl(httpsOrigin, envBasePath || '');
  }

  // 3) SSR fallback
  const fallback = process.env.NEXT_PUBLIC_BASE_URL || 'https://hubee.app';
  return joinUrl(ensureHttps(fallback), envBasePath || '');
};

export const API_CONFIG = {
  BASE_URL: getOcBaseUrl(),
} as const;